function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMiss = function SvgMiss(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 .5a9 9 0 1 0 .001 18.001A9 9 0 0 0 9 .5",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 0a9 9 0 1 0 .001 18.001A9 9 0 0 0 9 0",
    style: {
      fill: "#ee6b55"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.99 12.51s.06.08.08.13a.4.4 0 0 1 0 .3c-.02.05-.05.09-.08.13l-1.37 1.37s-.08.06-.13.08a.4.4 0 0 1-.3 0c-.05-.02-.09-.05-.13-.08L9 11.38l-3.06 3.06s-.08.06-.13.08a.4.4 0 0 1-.3 0c-.05-.02-.09-.05-.13-.08l-1.37-1.37a.41.41 0 0 1 0-.56l3.06-3.06-3.06-3.06a.41.41 0 0 1 0-.56l1.37-1.37a.41.41 0 0 1 .56 0L9 7.52l3.06-3.06a.41.41 0 0 1 .56 0l1.37 1.37s.06.08.08.13a.4.4 0 0 1 0 .3c-.02.05-.05.09-.08.13l-3.06 3.06z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.99 12.01s.06.08.08.13a.4.4 0 0 1 0 .3c-.02.05-.05.09-.08.13l-1.37 1.37s-.08.06-.13.08a.4.4 0 0 1-.3 0c-.05-.02-.09-.05-.13-.08L9 10.88l-3.06 3.06s-.08.06-.13.08a.4.4 0 0 1-.3 0c-.05-.02-.09-.05-.13-.08l-1.37-1.37a.41.41 0 0 1 0-.56l3.06-3.06-3.06-3.06a.41.41 0 0 1 0-.56l1.37-1.37a.41.41 0 0 1 .56 0L9 7.02l3.06-3.06a.41.41 0 0 1 .56 0l1.37 1.37s.06.08.08.13a.4.4 0 0 1 0 .3c-.02.05-.05.09-.08.13l-3.06 3.06z",
    style: {
      fill: "#f1f2f2"
    }
  }));
};
export default SvgMiss;